import { render, staticRenderFns } from "./InterpretationPendingForm.vue?vue&type=template&id=695bb369&"
import script from "./InterpretationPendingForm.vue?vue&type=script&lang=js&"
export * from "./InterpretationPendingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports